import React from "react";
import { Tabs, Stack, Title, Text, Box } from "@mantine/core";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ADMIN_TAB_ROOT_STYLE, ADMIN_TAB_CONTENT_STYLE } from "../adminTabLayout";

export const UserAdministration: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const activeTab = location.pathname.includes("/analytics") ? "analytics" : "directory";

    const handleTabChange = (value: string | null) => {
        if (!value || value === activeTab) {
            return;
        }

        const nextPath = value === "analytics" ? "/administration/users/analytics" : "/administration/users/directory";
        navigate(nextPath);
    };

    return (
        <Stack gap="lg" style={ADMIN_TAB_ROOT_STYLE}>
            <Stack gap={4}>
                <Title order={2}>Users</Title>
                <Text size="sm" c="dimmed">
                    Monitor engagement, export accounts and view details.
                </Text>
            </Stack>

            <Tabs value={activeTab} onChange={handleTabChange} variant="pills" radius="md">
                <Tabs.List>
                    <Tabs.Tab value="directory">Directory</Tabs.Tab>
                    <Tabs.Tab value="analytics">Insights</Tabs.Tab>
                </Tabs.List>
            </Tabs>

            <Box pt="md" style={ADMIN_TAB_CONTENT_STYLE}>
                <Outlet />
            </Box>
        </Stack>
    );
};
